import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularAed: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_aed"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="aed icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 10"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M9.35554 9.66645H7.3211L6.53888 7.37756H2.9411L2.15888 9.66645H0.15332L3.5811 0.279785H5.92776L9.35554 9.66645ZM3.3811 5.92645H6.09776L4.73332 1.82979L3.38221 5.92645H3.3811ZM10.6055 9.66645V0.279785H17.6444V1.85756H12.5667V4.1909H16.5644V5.69867H12.5667V8.08756H17.8433V9.66645H10.6033H10.6055ZM23.0889 0.279785C24.5589 0.279785 25.6967 0.687563 26.5033 1.50201C27.3089 2.31867 27.7111 3.47534 27.7111 4.97312C27.7111 6.4709 27.3089 7.62868 26.5033 8.44312C25.6967 9.25868 24.5589 9.66645 23.0889 9.66645H19.4622V0.279785H23.0889ZM22.9889 8.10201C23.8811 8.10201 24.55 7.83645 24.9955 7.30534C25.4511 6.76534 25.6778 5.98756 25.6778 4.97312C25.6778 3.95867 25.45 3.18645 24.9955 2.65534C24.55 2.11423 23.8811 1.84423 22.99 1.84423H21.4255V8.10201H22.9889Z" />
      </svg>
    </span>
  );
};

export { RegularAed };
